// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateDocumentVersionsMutationVariables = Types.Exact<{
  setDocumentVersionsInput: Array<Types.AugmentedUpdateDocumentInput> | Types.AugmentedUpdateDocumentInput;
  clearDocumentVersionsInput: Array<Types.AugmentedUpdateDocumentInput> | Types.AugmentedUpdateDocumentInput;
}>;


export type UpdateDocumentVersionsMutation = { __typename?: 'Mutation', clearDocumentVersions: Array<{ __typename?: 'Document', id: string }>, updateDocuments: Array<{ __typename?: 'Document', id: string, name: string, type: Types.DocumentType, previousVersion?: { __typename?: 'Document', id: string, name: string, type: Types.DocumentType } | null, nextVersion?: { __typename?: 'Document', id: string, name: string, type: Types.DocumentType } | null }> };

export const Operations = {
  Mutation: {
    UpdateDocumentVersions: 'UpdateDocumentVersions' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const UpdateDocumentVersionsDocument = gql`
    mutation UpdateDocumentVersions($setDocumentVersionsInput: [AugmentedUpdateDocumentInput!]!, $clearDocumentVersionsInput: [AugmentedUpdateDocumentInput!]!) {
  clearDocumentVersions: updateDocuments(input: $clearDocumentVersionsInput) {
    id
  }
  updateDocuments(input: $setDocumentVersionsInput) {
    id
    name
    type
    previousVersion {
      id
      name
      type
    }
    nextVersion {
      id
      name
      type
    }
  }
}
    `;
export type UpdateDocumentVersionsMutationFn = Apollo.MutationFunction<UpdateDocumentVersionsMutation, UpdateDocumentVersionsMutationVariables>;

/**
 * __useUpdateDocumentVersionsMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentVersionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentVersionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentVersionsMutation, { data, loading, error }] = useUpdateDocumentVersionsMutation({
 *   variables: {
 *      setDocumentVersionsInput: // value for 'setDocumentVersionsInput'
 *      clearDocumentVersionsInput: // value for 'clearDocumentVersionsInput'
 *   },
 * });
 */
export function useUpdateDocumentVersionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentVersionsMutation, UpdateDocumentVersionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentVersionsMutation, UpdateDocumentVersionsMutationVariables>(UpdateDocumentVersionsDocument, options);
      }
export type UpdateDocumentVersionsMutationHookResult = ReturnType<typeof useUpdateDocumentVersionsMutation>;
export type UpdateDocumentVersionsMutationResult = Apollo.MutationResult<UpdateDocumentVersionsMutation>;
export type UpdateDocumentVersionsMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentVersionsMutation, UpdateDocumentVersionsMutationVariables>;